import React, { useState, useEffect, useRef } from 'react';
import './css/historico.css';
import ImageSlider from './ImageSlider.jsx';

import egoi5 from './assets/historico/oifem V/egoi5.jpeg';
import oifem5_foto2 from './assets/historico/oifem V/fotos/OIFem 2025-162.jpg';
import oifem5_foto3 from './assets/historico/oifem V/fotos/OIFem 2025-158.jpg';
import oifem5_foto4 from './assets/historico/oifem V/fotos/OIFem 2025-140.jpg';
import oifem5_foto5 from './assets/historico/oifem V/fotos/OIFem 2025-116.jpg';
import oifem5_foto6 from './assets/historico/oifem V/fotos/OIFem 2025-95.jpg';
import oifem5_foto7 from './assets/historico/oifem V/fotos/OIFem 2025-77.jpg';
import oifem5_foto8 from './assets/historico/oifem V/fotos/OIFem 2025-3.jpg';

import ariadnaFranch from './assets/historico/oifem V/comentarios/ariadna_franch.jpg';
import inesDavila from './assets/historico/oifem V/comentarios/ines_davila.jpg';

import egoi4 from './assets/historico/oifem IV/oifem4_foto1.jpg';
import oifem4_foto2 from './assets/historico/oifem IV/fotos/P1110506.jpg';
import oifem4_foto3 from './assets/historico/oifem IV/fotos/DSC_0034.jpg';
import oifem4_foto4 from './assets/historico/oifem IV/fotos/P1110559.jpg';
import oifem4_foto5 from './assets/historico/oifem IV/fotos/DSC_0187.jpg';
import oifem4_foto6 from './assets/historico/oifem IV/fotos/DSC_0010.jpg';
import oifem4_foto7 from './assets/historico/oifem IV/fotos/P1110318.jpg';

import egoi3 from './assets/historico/oifem III/fotos/oifem3_foto1.JPG';
import oifem3_foto2 from './assets/historico/oifem III/fotos/oifem3_foto2.JPG';
import oifem3_foto3 from './assets/historico/oifem III/fotos/oifem3_foto3.JPG';
import oifem3_foto4 from './assets/historico/oifem III/fotos/oifem3_foto4.JPG';
import oifem3_foto5 from './assets/historico/oifem III/fotos/oifem3_foto5.JPG';
import oifem3_foto6 from './assets/historico/oifem III/fotos/oifem3_foto6.JPG';
import oifem3_foto7 from './assets/historico/oifem III/fotos/oifem3_foto7.JPG';
import oifem3_foto8 from './assets/historico/oifem III/fotos/oifem3_foto8.JPG';
import oifem3_foto9 from './assets/historico/oifem III/fotos/oifem3_foto9.JPG';

import eulalia from './assets/historico/oifem III/comentarios/eulalia.png';
import elena from './assets/historico/oifem III/comentarios/elena.png';
import alexia from './assets/historico/oifem III/comentarios/alexia.png';
import adriana from './assets/colaboradores/adriana.png';
import amal from './assets/historico/oifem II/comentarios/amal.png';
import ariadna from './assets/historico/oifem II/comentarios/ariadna.png';
import irene from './assets/historico/oifem II/comentarios/irene.png';
import lucia from './assets/historico/oifem I/comentarios/lucia.png';
import victoria from './assets/historico/oifem I/comentarios/victoria.png';

import egoi2 from './assets/historico/oifem II/fotos/egoi2.jpg';
import oifem2_foto1 from './assets/historico/oifem II/fotos/concurso1.JPG';
import oifem2_foto2 from './assets/historico/oifem II/fotos/concurso2.JPG';
import oifem2_foto3 from './assets/historico/oifem II/fotos/concurso3.JPG';
import oifem2_foto4 from './assets/historico/oifem II/fotos/concurso4.jpg';
import oifem2_foto5 from './assets/historico/oifem II/fotos/concurso5.JPG';
import oifem2_foto6 from './assets/historico/oifem II/fotos/concurso6.JPG';
import oifem2_foto7 from './assets/historico/oifem II/fotos/concurso7.JPG';

import egoi1 from './assets/historico/oifem I/oifem1_foto2.jpg';
import oifem1_foto1 from './assets/historico/oifem I/oifem1_foto1.jpg';
import oifem1_foto2 from './assets/historico/oifem I/oifem1_foto3.jpg';
import oifem1_foto3 from './assets/historico/oifem I/oifem1_foto4.jpeg';
import oifem1_foto4 from './assets/historico/oifem I/oifem1_foto5.jpeg';
import oifem1_foto5 from './assets/historico/oifem I/oifem1_foto6.jpeg';
import oifem1_foto6 from './assets/historico/oifem I/oifem1_foto7.jpeg';
import oifem1_foto7 from './assets/historico/oifem I/oifem1_foto8.jpeg';
import oifem1_foto8 from './assets/historico/oifem I/oifem1_foto9.jpeg';
import oifem1_foto9 from './assets/historico/oifem I/oifem1_foto10.jpeg';

import oifemFinal1 from "./assets/files/oifem1/final1.pdf";
import oifemFinal2 from "./assets/files/oifem1/final2.pdf";
import solucionesConcurso1oifem1 from "./assets/files/oifem1/clasificatorio.pdf";
import oifem2Clasificatorio from "./assets/files/oifem2/clasificatorio.pdf";
import oifem2Final1 from "./assets/files/oifem2/final_dia1.pdf";
import oifem2Final2 from "./assets/files/oifem2/final_dia2.pdf";
import problemasOifem3Final1 from "./assets/files/oifem3/final_dia1.pdf";
import problemasOifem3Final2 from "./assets/files/oifem3/final_dia2.pdf";
import problemasOifem4Final from './assets/historico/oifem IV/concursos/Problemas_Final_OIFem_IV.pdf';
import solucionesOifem4Final from './assets/historico/oifem IV/concursos/Soluciones_Final_OIFem_IV (2).pdf';
import problemasOifem5Dia1 from './assets/historico/oifem V/concursos/Final_OIFem_V_dia_1.pdf';
import problemasOifem5Dia2 from './assets/historico/oifem V/concursos/Final_OIFem_V_dia_2.pdf';
import solucionesOifem5Dia1 from './assets/historico/oifem V/concursos/Soluciones_Final_OIFem_V_dia_1.pdf';
import solucionesOifem5Dia2 from './assets/historico/oifem V/concursos/Soluciones_Final_OIFem_V_dia_2.pdf';
import egoi5Dia1 from './assets/historico/oifem V/concursos/EGOI_dia_1.pdf'
import egoi5Dia2 from './assets/historico/oifem V/concursos/EGOI_dia_2.pdf'

const MedalList = ({ title, items }) => (
  <div>
    <h3>{title}</h3>
    {items.map((item, index) => (
      <p key={index}>{item.nombre} - {item.medalla}</p>
    ))}
  </div>
);

const NameList = ({ title, items }) => (
  <div>
    <h3>{title}</h3>
    {items.map((item, index) => (
      <p key={index}>{item.nombre}</p>
    ))}
  </div>
);

const ContestSection = ({ contests }) => (
  <div className="concursos">
    <h3>Concursos</h3>
    {contests.map((c, index) => (
      <div key={index}>
        <h4>{c.nombre}</h4>
        <div className='concurso'>
          <div className='problemas'>
            <p>Problemas:</p>
            {c.problemas.map((p, i) => (
              <a key={i} href={p.url} target="_blank" rel="noopener noreferrer">{p.nombre}</a>
            ))}
          </div>
          {c.soluciones.length > 0 && (
            <div className='soluciones'>
              <p>Soluciones:</p>
              {c.soluciones.map((p, i) => (
                <a key={i} href={p.url} target="_blank" rel="noopener noreferrer">{p.nombre}</a>
              ))}
            </div>
          )}
        </div>
      </div>
    ))}
  </div>
);

const CommentSection = ({ comments }) => (
  <div className='comentarios'>
    {comments.map((c, index) => (
      <div className={`comentario ${c.className || ''}`} key={index}>
        <div className='img-div'><img src={c.foto} alt={c.nombre}/></div>
        <p><b>{c.nombre}</b></p>
        {c.mensajes.map((m, i) => (
          <p key={`mensaje-${i}`}>{m}</p>
        ))}
      </div>
    ))}
  </div>
);

const OtherCompetitions = ({ competitions }) => (
  <div className={`otras-competiciones columns${competitions.length > 2 ? '3' : '2'}`}>
    {competitions.map((comp, index) => (
      <div key={index}>
        <h4>{comp.titulo}</h4>
        {comp.items.map((item, i) => (
          <p key={i}>{item}</p>
        ))}
      </div>
    ))}
  </div>
);

const EditionSection = ({ edition }) => (
  <div className='edicion' key={edition.id}>
    <StickyEditionHeader title={edition.nombre} id={edition.id} />
    <div className='ediciones'>
      <div className='ediciones-left'>
        {edition.descripciones.map((descripcion, i) => (
            <p>{descripcion}</p>
        ))}
        
        {edition.egoiImage && (
          <div className='egoi'>
            <h2>Olimpiada Europea Femenina de Informática (EGOI)</h2>
            <img src={edition.egoiImage} alt={`EGOI ${edition.nombre}`}/>
            {edition.egoiDescripcion && <p>{edition.egoiDescripcion}</p>}
            {edition.egoiLinks && edition.egoiLinks.length > 0 && edition.egoiLinks.map((link) => <p><a href={link.url}>{link.title}</a></p>)}
            <h3>Resultados del equipo</h3>
            {edition.teamEgoi.map((p, index) => (
              <p key={index}>{p.nombre} - {p.medalla}</p>
            ))}
          </div>
        )}
      </div>

      <div className='ediciones-right'>
        <h2>Final nacional</h2>
        
        <MedalList title="Medallistas" items={edition.medallistas} />
        <NameList title="Finalistas" items={edition.finalistas} />
        
        {edition.premiosESO && edition.premiosESO.length > 0 && (
          <div>
            <h3>Premiadas ESO</h3>
            {edition.premiosESO.map((premio, i) => (
              <p key={i}>{premio}</p>
            ))}
          </div>
        )}

        {edition.premiosPrimaria && edition.premiosPrimaria.length > 0 && (
          <div>
            <h3>Reconocimiento a participantes de primaria</h3>
            {edition.premiosPrimaria.map((premio, i) => (
              <p key={i}>{premio}</p>
            ))}
          </div>
        )}

        {edition.premioCamiseta && 
          <div>
            <h3>Ganadora del diseño de camisetas</h3>
            <p>{edition.premioCamiseta}</p>
          </div>}

        {edition.premioCentro && (
          <div>
            <h3>Premio al centro con más participantes en el concurso</h3>
            <p>{edition.premioCentro}</p>
          </div>
        )}

        <ContestSection contests={edition.concursos} />
      </div>
    </div>

    {edition.otrasCompeticiones && edition.otrasCompeticiones.length > 0 && (
      <>
        <h2>Resultados en otras competiciones</h2>
        <OtherCompetitions competitions={edition.otrasCompeticiones} />
      </>
    )}

    {edition.comentarios && edition.comentarios.length > 0 && (
      <>
        <h2>Comentarios</h2>
        <CommentSection comments={edition.comentarios} />
      </>
    )}

    <h2>Fotos</h2>
    <ImageSlider images={edition.fotos} />
  </div>
);


const StickyEditionHeader = ({ title, id }) => {
  const [isSticky, setIsSticky] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting);
      },
      { threshold: [1] }
    );

    if (headerRef.current) {
      observer.observe(headerRef.current);
    }

    return () => {
      if (headerRef.current) {
        observer.unobserve(headerRef.current);
      }
    };
  }, []);

  const Heading = isSticky ? 'h3' : 'h1';

  return (
    <>
      <div ref={headerRef} className="sticky-sentinel" style={{ height: '1px' }}></div>
      <div className={`sticky-edition-header ${isSticky ? 'sticky' : ''}`}>
        <Heading id={id}>{title}</Heading>
      </div>
    </>
  );
};


export default function Historico() {
  const [edicionSeleccionada, setEdicionSeleccionada] = useState("todas");

  useEffect(() => {
    if (edicionSeleccionada !== "todas") {
      const element = document.getElementById(edicionSeleccionada);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [edicionSeleccionada]);

  
  const ediciones = [
    {
      id: "oifem-v",
      nombre: "OIFem V (2025)",
      teamEgoi: [
        {nombre: "Vera Morancho Bargas", medalla: "medalla de bronce"},
        {nombre: "Eulàlia Gaya Bretones", medalla: "medalla de bronce"},
        {nombre: "Ariadna Franch Pérez", medalla: "medalla de bronce"},
        {nombre: "Elena Boix Miralles", medalla: "mención de honor"}
      ],
      medallistas: [
        {nombre: "Ariadna Franch", medalla: "medalla de oro"},
        {nombre: "Eulàlia Gaya", medalla: "medalla de plata"},
        {nombre: "Vera Morancho", medalla: "medalla de bronce"},
        {nombre: "Elena Boix", medalla: "medalla de bronce"},
      ],
      finalistas: [
        {nombre: "Marina Garcia"},
        {nombre: "Shuwen Wang"},
        {nombre: "Camila Jonsson"},
        {nombre: "Alba Martinez"},
        {nombre: "Lorena Badesa"},
        {nombre: "Antònia Sureda"},
        {nombre: "Inés Dávila"},
        {nombre: "Ariadna Puertas"},
        {nombre: "María Castro"},
        {nombre: "Celia Leyva"},
        {nombre: "Abril Catalán"}
      ],
      concursos: [
        {
          nombre: "OIFem",
          problemas: [
            {nombre: "Final día 1", url: problemasOifem5Dia1},
            {nombre: "Final día 2", url: problemasOifem5Dia2}
          ],
          soluciones: [
            {nombre: "Final día 1", url: solucionesOifem5Dia1},
            {nombre: "Final día 2", url: solucionesOifem5Dia2}
          ]
        },
        {
          nombre: "EGOI",
          problemas: [
            {nombre: "Día 1", url: egoi5Dia1},
            {nombre: "Día 2", url: egoi5Dia2}
          ],
          soluciones: []
        }
      ],
      fotos: [oifem5_foto2, oifem5_foto3, oifem5_foto4, oifem5_foto5, oifem5_foto6, oifem5_foto7, oifem5_foto8],
      comentarios: [
        {
            foto: ariadnaFranch,
            nombre: "Ariadna",
            mensajes: ["Este ha sido ya mi cuarto año participando en la OIFem y puedo afirmar que apuntarme fue la mejor decisión que podía tomar, porque si el hecho de que haya muy pocas chicas en el mundo de la informática puede tener algo bueno, es que existen proyectos como este. Y es que, sin la OIFem, muy probablemente no habría llegado nunca a competir al nivel al que lo hago ahora, tal vez ni siquiera me habría interesado por la programación competitiva. Gracias a las clases y a la ayuda de los entrenadores pude aprender poco a poco, enfrentándome a nuevos retos, para luego vivir la emoción de una competición en vivo. Además, poder conocer a chicas increíbles con los mismos intereses que yo, varias de las cuales son ahora buenas amigas mías, con las que he pasado muy buenos momentos, ha sido una gran motivación para seguir mejorando. Ha sido un camino largo y no siempre fácil, que me ha ayudado a crecer, no sólo como programadora, sino también como persona, al hacerme ganar confianza en mí misma y enseñarme cómo enfrentar situaciones tan exigentes como lo es una competición, o incluso cómo hacer frente al fracaso. Por todo esto, estoy plenamente agradecida a todo el equipo de la OIFem, ya que es gracias a todo su esfuerzo y trabajo que he podido vivir tan buenas y enriquecedoras experiencias. Ahora que, por desgracia, ya no puedo volver a participar, haré todo lo que esté en mi mano para que otras chicas podáis viváis experiencias tan bonitas como las que yo he vivido. ¡No dudéis en apuntaros!"]
        },
        {
            foto: inesDavila,
            nombre: "Inés",
            mensajes: ["Ha sido una de las mejores experiencias que he vivido en una olimpiada. En todo momento hemos tenido a alguien disponible para ayudarnos, no solo durante la olimpiada sino durante todo el curso y eso es algo por lo que le estaré siempre agradecida a la organización. Participé por primera vez hace cuatro años y gracias a las clases he aprendido muchísimo. Desde lo más básico hasta algoritmos complejos que al principio jamás se me habría ocurrido que aprendería a implementar. Finalmente, tuve la oportunidad de participar en la final en Barcelona y pude conocer a muchas chicas con intereses similares a los míos con las que me lo pasé genial. Espero que se sigan apuntando muchas chicas y que tengan una experiencia tan bonita como la que las voluntarias han permitido que tenga yo."]
        }
      ],
      otrasCompeticiones: [
        {
          titulo: "Olimpiada Informática Española",
          items: [
            "Eulàlia Gaya - medalla de oro",
            "Ariadna Franch - medalla de bronce",
            "Ariadna Puertas - finalista"
          ]
        },
        {
          titulo: "Olimpiada Informática Iberoamericana",
          items: [
            "Ariadna Franch - medalla de oro",
            "Eulàlia Gaya - medalla de plata"
          ]
        }
      ],
      descripciones: ["El primer clasificatorio de la quinta edición de la OIFem tuvo lugar del 24 al 26 de enero, el segundo clasificatorio tuvo lugar el 8 de febrero y la final del 6 al 9 de marzo."],
      egoiDescripcion: "La EGOI 2025 tendrá lugar del 14 al 20 de julio en Bonn, Alemania",
      egoiImage: egoi5,
      premiosESO: [
        " Lorena Badesa - mejor puntuación de 3º y 4º de la ESO"
      ],
      premiosPrimaria: [
        "Diana Sáez por clasificarse a la final"
      ],
      premioCamiseta: "Brittany"
    },

    {
      id: "oifem-iv",
      nombre: "OIFem IV (2024)",
      teamEgoi: [
        {nombre: 'Ariadna Franch Pérez', medalla: 'Mención de Honor'},
        {nombre: 'Eulàlia Gaya Bretones', medalla: 'Medalla de bronce'},
        {nombre: 'Vera Morancho Bargas', medalla: 'Medalla de bronce'},
        {nombre: 'Lidia Casado Cases', medalla: 'Participación'}
      ],
      medallistas: [
        {nombre: "Ariadna Franch Pérez", medalla: "medalla de oro"},
        {nombre: "Eulàlia Gaya Bretones", medalla: "medalla de plata"},
        {nombre: "Vera Morancho Bargas", medalla: "medalla de bronce"},
        {nombre: "Lidia Casado Cases", medalla: "medalla de bronce"},
      ],
      finalistas: [
        {nombre: "Ekaterina Leksina"},
        {nombre: "Elena Boix Miralles"},
        {nombre: "Marina Gurova"},
        {nombre: "Alba Martínez Mayol"},
        {nombre: "Shuwen Wang"},
        {nombre: "Camilla Jonsson Giaconi"},
        {nombre: "Marina García Méndez"},
        {nombre: "Ariadna Puertas"},
        {nombre: "Lorena Badesa"},
        {nombre: "Lara Gálvez Ferrufino"},
        {nombre: "Inés González Valdés"},
      ],
      concursos: [
        {
            nombre: "OIFem",
            problemas: [
                {url: problemasOifem4Final, nombre: "Problemas Final"},
            ],
            soluciones: [
                {url: solucionesOifem4Final, nombre: "Soluciones Final"},
            ]
        },
        {
          nombre: "EGOI",
          problemas: [
            {url: "https://stats.egoi.org/editions/2024/editions/", nombre: "Problems EGOI 2024"}
          ],
          soluciones: []
        }
      ],
      fotos: [oifem4_foto2, oifem4_foto3, oifem4_foto4, oifem4_foto5, oifem4_foto6, oifem4_foto7],
      comentarios: [],
      otrasCompeticiones: [
        {
          titulo: "Olimpiada Informática Española",
          items: [
            "Ariadna Franch Cortés- Medalla de bronce y premio del Ministerio de Educación y FP a la mejor puntuación femenina",
            "Lidia Casado Cases- Medalla de bronce y premio del Ministerio de Educación y FP a la seguda mejor puntuación femenina"
          ]
        },
        {
          titulo: "Western Olympiad in Informatics (WEOI)",
          items: [
            "Ariadna Franch Cortés - Medalla de bronce",
            "Eulàlia Gaya Bretones - Medalla de bronce"
          ]
        },
        {
          titulo: "Olimpiada Iberoamericana de Informática (OII)",
          items: [
            "Ariadna Franch Cortés - Medalla de plata"
          ]
        }
      ],
      descripciones: [
        "La cuarta edición de la OIFem tuvo lugar en Barcelona del 7 al 10 de marzo.",
        "Pese a que nos acerquemos, de los voluntarios que estamos a lo largo del año, todos los que podemos, en la final siempre se necesita mucha ayuda, por lo que agradecemos enormemente a quienes se acercan a colaborar esa semana. Vinieron a ayudar como voluntarias durante la final Marta Alet Puig, Sílvia Fàbregas Salazar, Júlia Muñoz Torrico, Ruth Mora Soto, Jordina Gavaldà Rovira, Alèxia Escudero Ribó, Ariadna Cortés Danés, Laia Mogas Pladevall, además de los organizadores y profesores Joana Pech Alberich, Mar González Català, Blanca Huergo Muñoz, María Lucía Aparicio García, Adriana Aguiló Martínez, Amal Dokkar El Hamoudi, Jacobo Vilella Vilahur, Cesc Folch Aldehuelo, Joan Alemany Flos e Izan Beltran Ferreiro."
      ],
      egoiImage: egoi4,
      egoiDescripcion: "La EGOI de este año ha tenido lugar del 21 al 27 de julio en Eindhoven, Países Bajos.",
      premiosESO: [
        "Vera Morancho Bargas - mejor puntuación de 3º y 4º de la ESO"
      ]
    },

    {
      id: "oifem-iii",
      nombre: "OIFem III (2023)",
      teamEgoi: [
        {nombre: "Adriana Aguiló Martínez", medalla: "Medalla de bronce"},
        {nombre: "Amal Dokkar El Hamoudi", medalla: "Mención de honor"},
        {nombre: "Eulàlia Gaya Bretones", medalla: "Participación"},
        {nombre: "Helena Folia Cots", medalla: "Participación"},
      ],
      medallistas: [
        {nombre: "Adriana Aguiló Martínez", medalla: "medalla de oro"},
        {nombre: "Amal Dokkar El Hamoudi", medalla: "medalla de plata"},
        {nombre: "Eulàlia Gaya Bretones", medalla: "medalla de bronce"},
        {nombre: "Helena Folia Cots", medalla: "medalla de bronce"},
      ],
      finalistas: [
        {nombre: "Ariadna Franch Pérez"},
        {nombre: "Maria Borrell"},
        {nombre: "Alèxia Escudero Ribó"},
        {nombre: "Elena Boix Miralles"},
        {nombre: "Jordina Gavaldà Rovira"},
        {nombre: "Polina Redina Chupina"},
        {nombre: "Vera Morancho Bargas"},
        {nombre: "Teresa Marín Marín"},
        {nombre: "Naia Ongay Zaratiegui"},
        {nombre: "Shuwen Wang"},
        {nombre: "Camilla Jonsson Giaconi"},
      ],
      concursos: [
        {
            nombre: "OIFem",
            problemas: [
                {url: problemasOifem3Final1, nombre: "Final Día 1"},
                {url: problemasOifem3Final2, nombre: "Final Día 2"}
            ],
            soluciones: []
        },
        {
            nombre: "EGOI",
            problemas: [
                {url: "https://stats.egoi.org/editions/2023/editions/", nombre: "Problems EGOI 2023"}
            ],
            soluciones: []
        }
      ],
      fotos: [oifem3_foto2, oifem3_foto3, oifem3_foto4, oifem3_foto5, oifem3_foto6, oifem3_foto7, oifem3_foto8, oifem3_foto9],
      comentarios: [
        {
            foto: eulalia,
            mensajes: ["Participar en la OIFem realmente es una de las mejores experiencias que he vivido. Lo que más valoro es el ambiente que se crea. Evidentemente, durante la competición hay cierta rivalidad entre nosotras, pero es bonito ver como, cuando estas cuatro horas y media terminan, esta competitividad desaparece por completo y en lugar de oponentes nos volvemos un solo equipo. Es una gran oportunidad para conocer a gente con inquietudes similares y hacer nuevas amistades. Es esto lo que me motiva para volver a repetir tantos años como pueda."],
            nombre: "Eulàlia"
        },
        {
            foto: elena,
            mensajes: ["Conocer la OIFem ha supuesto un cambio para mí. He descubierto el mundo de la programación competitiva desde un punto de vista motivador y emocionante. Sin esta iniciativa probablemente nunca habría llegado a programar al nivel al que lo hago ahora. Con la OIFem he descubierto una pasión que no sabía que tenía, y a la que me gustaría dedicarme en un futuro. Sin lugar a dudas, el año que viene continuaré participando, pues con las clases cada año se aprende más. Es una experiencia única en la haces muchas amistades con los mismos intereses que tú, convirtiéndose en una comunidad. Conocer a las finalistas y a la organización de este concurso en persona ha sido para mí el mejor premio, además de una experiencia que nunca olvidaré."],
            nombre: "Elena"
        },
        {
            foto: alexia,
            mensajes: [
                "Fue gracias a la OIFem que entré en el mundo de la programación competitiva. Gracias a las múltiples clases que se ofrecen y el esfuerzo de todo el equipo de la OIFem he mejorado muchísimo en este ámbito. Además, he conocido a muchas otras chicas con intereses similares a los míos. Así, la OIFem ha sido muchísimo más que un simple concurso para mí: ha sido una experiencia única y muy enriquecedora tanto educativamente como socialmente. No se trata de solamente los cuatro dias que dura la final, ni tan solo de el curso escolar durante el cual vas haciendo los entrenamientos, sino de algo que durará toda la vida, ya que todo lo aprendido y lo vivido no se va a olvidar fácilmente.",
                "Quería agradecer muchísimo a todo el equipo de la OIFem su trabajo, ya que la competición está muy bien organizada en todos los aspectos, desde los entrenamientos, de máxima calidad, pasando por la comunidad que se forma y finalmente, en la organización de la final, con un montón de actividades y sorpresas preparadas. Para todas las que estén dudando de si apuntarse: ni os lo penséis. Tendréis entrenamientos para aprender a programar sea cual sea vuestro nivel, cosa que os abrirá muchas puertas, y haréis muchas amistades. Conocer la OIFem ha sido de las mejores experiencias, y seguro que tambien lo será para vosotras."
            ],
            nombre: "Alèxia"
        },
        {
            foto: adriana,
            mensajes: [
                "Empecé a competir hará tres años, con la OIFem. Y lo que más vértigo me da es que fuera pura casualidad, porque se me cancelara una clase de tenis. A esta casualidad le debo programar en C++, la carrera que quiero estudiar, un viaje a Turquía. Si empezáis a competir aprenderéis mucho, y los entrenadores darán todo por ayudaros a crecer, pero lo más importante es que crecer no quiere decir simplemente aprender algoritmos.",
                "Miro atrás y encuentro mil instantes que paralizaría durante una eternidad. Acabo este último año de competición con un sabor agridulce, con la emoción por todo lo que la OIFem empezó confrontada con el amargor de saber que le ha llegado el momento de acabar. Es una experiencia que repetiría sin saciarme y, aunque yo ya no puedo, estaré trabajando para que vosotras viváis esta etapa de vuestra vida con más intensidad incluso de cómo lo hice yo, así que os invito a venir. Creo que las siete letras que componen la palabra \"gracias\" son insuficientes para recoger mi agradecimiento."
            ],
            nombre: "Adriana"
        },
      ],
      otrasCompeticiones: [
        {
            titulo: "Olimpiada Informática Española",
            items: [
                "Adriana Aguiló Martínez - premio del Ministerio de Educación y FP (1000 euros) a la mejor puntuación femenina",
                "Helena Folia Cots - premio del Ministerio de Educación y FP (1000 euros) a la segunda mejor puntuación femenina",
                "Ariadna Franch Pérez - finalista"
            ]
        },
        {
            titulo: "HP Codewars", items: ["Adriana Aguiló Martínez, Amal Dokkar El Hamoudi y Helena Folia Cots - ganadoras absolutas del concurso entre más de cien equipos. Primer equipo femenino de la historia en lograrlo."]
        }
      ],
      descripciones: [
        "Tras la experiencia de la OIFem II, la primera en persona, nos hacía mucha ilusión volver a reunirnos con las alumnas, aunque con algunas sería como voluntarias, al haberse graduado ya de Secundaria. Aunque aún faltan unos meses para dar final a esta tercera edición de la OIFem, ya estamos muy satisfechos con los resultados. Este año hemos partido los entrenamientos en 4 niveles, que juntos completan el syllabus de la EGOI. Con respecto a la final, hemos repetido Barcelona como sede, dado lo bien que resultó el concurso anterior en el CFIS-UPC. Las actividades que realizamos fueron un escape room para conocer la ciudad mientras hablaban en grupos pequeños y hacían amigas, además de una visita completa a la Sagrada Familia. Como novedades a destacar del formato del concurso de este año, añadimos una ronda más online antes de la final, partiendo el clasificatorio en dos fases sucesivas. Además, organizamos un concurso de diseño de camisetas, con la idea de que las concursantes pudieran diseñar y escoger la camiseta de la final. Lo ganó Amal Dokkar El Hamoudi.",
        "Pese a que nos acerquemos, de los voluntarios que estamos a lo largo del año, todos los que podemos, en la final siempre se necesita mucha ayuda, por lo que agradecemos enormemente a quienes se acercan a colaborar esa semana. Vinieron a ayudar como voluntarias durante la final Marta Alet Puig, Sílvia Fàbregas Salazar, Júlia Muñoz Torrico, Ángela Rodríguez Izquierdo, además de los organizadores y profesores Joana Pech Alberich, Mar González Català, Blanca Huergo Muñoz, María Lucía Aparicio García, Jacobo Vilella Vilahur, Cesc Folch Aldehuelo, Joan Alemany Flos e Izan Beltran Ferreiro."
      ],
      egoiImage: egoi3,
      egoiDescripcion: "La tercera edición de la EGOI tuvo lugar en Lund, Suecia del 15 al 21 de julio.",
      premiosESO: [
        "Lorena Badesa Pérez - mejor puntuación de 1º y 2º de la ESO",
        "Eulàlia Gaya Bretones - mejor puntuación de 3º y 4º de la ESO"
      ],
      premioCentro: "Aula Escola Europea (Barcelona)"
    },
    
    {
      id: "oifem-ii",
      nombre: "OIFem II (2022)",
      teamEgoi: [
        {nombre: "María Lucía Aparicio García", medalla: "medalla de plata"},
        {nombre: "Laura Mandow Fuentes", medalla: "medalla de plata"},
        {nombre: "Adriana Aguiló Martínez", medalla: "medalla de bronce"},
        {nombre: "Amal Dokkar El Hamoudi", medalla: "medalla de bronce"},
      ],
      medallistas: [
        {nombre: "María Lucía Aparicio García", medalla: "medalla de oro"},
        {nombre: "Laura Mandow Fuentes", medalla: "medalla de plata"},
        {nombre: "Amal Dokkar El Hamoudi", medalla: "medalla de bronce"},
        {nombre: "Adriana Aguiló Martínez", medalla: "medalla de bronce"}
      ],
      finalistas: [
        {nombre: "Helena Folia Cots"},
        {nombre: "Alèxia Escudero Ribó"},
        {nombre: "Paula Taibo Suárez"},
        {nombre: "Polina Redina Chupina"},
        {nombre: "Isabel Villar García"},
        {nombre: "Eulàlia Gaya Bretones"},
        {nombre: "Jordina Gavaldà Rovira"},
        {nombre: "Ariadna Franch Pérez"},
        {nombre: "Vera Morancho Bargas"},
        {nombre: "Laia Mayné Arévalo"},
        {nombre: "Irene Valdés Martín"},
      ],
      concursos: [
        {
            nombre: "OIFem",
            problemas: [
                { url: "https://www.hackerrank.com/contests/oifem-ii-clasificatorio/challenges", nombre: "Problemas Concurso clasificatorio (13/03/22)"},
                { url: "https://www.hackerrank.com/contests/oifem-ii-final-dia-1/challenges", nombre: "Problemas Final Día 1 (08/04/22)"},
                { url: "https://www.hackerrank.com/contests/oifem-ii-final-dia-2/challenges", nombre: "Problemas Final Día 2 (09/04/22)"}
            ],
            soluciones: [
                { url: oifem2Clasificatorio, nombre: "Soluciones Concurso clasificatorio (13/03/22)"},
                { url: oifem2Final1, nombre: "Soluciones Final Día 1 (08/04/22)"},
                { url: oifem2Final2, nombre: "Soluciones Final Día 2 (09/04/22)"}
            ] 
        },
        {
            nombre: "EGOI",
            problemas: [
                {url: "https://stats.egoi.org/editions/2022/editions/", nombre: "Problemas EGOI 2022"}
            ],
            soluciones: []
        }
      ],
      fotos: [oifem2_foto1, oifem2_foto2, oifem2_foto3, oifem2_foto4, oifem2_foto5, oifem2_foto6, oifem2_foto7],
      comentarios: [
        {
            foto: amal,
            mensajes: [
                "Esta ha sido mi segunda OIFem, pero por suerte no va a ser la última. Para mí la OIFem ha sido mi primer contacto con el mundillo de la programación competitiva y es al que le guardo más cariño. Aparte de la competición, que sólo son unos días contados, la OIFem es mucho más, y tal vez todo eso no se ve. Hay un montón de organizadores y voluntarios que a lo largo del curso nos han impartido clases y dado materiales para formarnos, además de diseñar los problemas de los concursos y organizar los viajes. Luego están todas las chicas que durante el curso han estado dedicando horas a la programación simplemente por gusto. Esta pequeña comunidad es lo que más me gusta, ya que convierte una olimpiada nacional en algo más cercano. ¡¡A por la tercera OIFem!!"
            ],
            nombre: "Amal"
        },
        {
            foto: adriana,
            mensajes: [
                "Sin la OIFem no habría entrado jamás en el mundo de la programación competitiva ni habría conocido a las que ahora conforman mi círculo social. Ha sido la mejor oportunidad que he tenido nunca para llegar lejos en un ámbito, pero ante todo ha sido una oportunidad extraordinaria para creer en mí misma. Los entrenadores consiguen que el temario resulte asequible y, al mismo tiempo, increíblemente estimulante. Siempre están ahí, ayudando a que todas seamos capaces de superarnos a nosotras mismas y llegar a niveles de rendimiento insospechados. Además, la OIFem tiene un punto añadido, y es que estamos mucho más unidas mediante eventos sociales y el contacto estrecho con los problem setters y entrenadores. De verdad que recomiendo esta experiencia a cualquiera, a que se atreva como yo me atreví en su momento, pues probablemente saldrá igual que yo: muy contenta y motivada."
            ],
            nombre: "Adriana"
        },
        {
            foto: alexia,
            mensajes: [
                "La OIFem ha sido, sin ninguna duda, una experiencia muy emocionante, enriquecedora y motivadora para mí. Por un lado, he podido conocer a muchas otras chicas con los mismos intereses que yo. Por otro lado, he aprendido un montón de programación en las clases que nos han sido ofrecidas. Siento que el esfuerzo hecho ha merecido muchísimo la pena. La organización del concurso fue, además, espectacular, con un montón de actividades y detalles preparados. Fue una experiencia inolvidable. Animo, sin duda alguna, a que todas las que aún no hayáis participado en el concurso, a participar el año que viene. ¡No os arrepentiréis de ello!"
            ],
            nombre: "Alèxia"
        },
        {
            foto: ariadna,
            mensajes: [
                "Agradezco todo el esfuerzo y el trabajo por parte del equipo de la OIFem, porque no solo me han permitido aprender programación competitiva, sino que me ha brindado la posibilidad de vivir una experiencia única. Es maravilloso poder formar parte de esta comunidad, donde además de conocer a chicas con intereses similares me he enfrentado a retos realmente enriquecedores. Tengo ganas de aprovechar al máximo los próximos años."
            ],
            nombre: "Ariadna"
        },
        {
            foto: irene,
            mensajes: [
                "Antes de la OIFem tenía unas nociones muy pobres de programación. Aún son pobres porque no acudí a muchas clases, pero he descubierto que los problemas me divierten y que aprender a resolverlos resulta muy satisfactorio. Tras haber concursado en la final, he conocido a muchas cracks que le ponen un gran empeño y esfuerzo a lo que hacen. Ver hasta dónde han llegado me motiva para practicar más y me deja con unas ganas de mejorar increíbles."
            ],
            nombre: "Irene"
        },
      ],
      otrasCompeticiones: [
        {
            titulo: "Olimpiada Informática Española",
            items: [
                "María Lucía Aparicio García - medalla de plata",
                "Adriana Aguiló Martínez - finalista",
                "Marta Sierra Obea - finalista",
                "Paula Taibo Suárez- finalista"
            ]
        },
        {
            titulo: "HP Codewars",
            items: [
                "Adriana Aguiló Martínez, Amal Dokkar El Hamoudi y Helena Folia Cots - premio al mejor equipo femenino"
            ]
        },
        {
            titulo: "Olimpiadas de informática regionales",
            items: [
                "María Lucía Aparicio García - ganadora de Asturias",
                "Marta Sierra Obea - ganadora de Aragón (modalidad algoritmia)",
                "Paula Taibo Suárez - segundo puesto de Galicia"
            ]
        }
      ],
      descripciones: [
        "La segunda edición de la OIFem fue la primera que logramos celebrar enteramente en persona. Pasamos unos días en Barcelona, donde las finalistas pudieron conocerse entre sí mientras disfrutaban de la ciudad, con visitas a la Pedrera (guiada por Gerard Segú, director de UNESCOCAT) y a la Sagrada Familia (guiada por David Puig, arquitecto adjunto de la Sagrada Familia). Además, las alumnas recibieron clases a lo largo del año, separadas en tres niveles, y obtuvieron un certificado como prueba de su esfuerzo. Esta segunda edición fue una experiencia muy divertida y el poder conocerse fue un gran premio al trabajo de estos dos años.",
        "Pese a que nos acerquemos, de los voluntarios que estamos a lo largo del año, todos los que podemos, en la final siempre se necesita mucha ayuda, por lo que agradecemos enormemente a quienes se acercan a colaborar esa semana. Vinieron a ayudar como voluntarias durante la final Marta Alet Puig, Paula Esquerrà Giné y Mar González Català, además de los organizadores y profesores Joana Pech Alberich, Blanca Huergo Muñoz, Jacobo Vilella Vilahur, Cesc Folch Aldehuelo, Joan Alemany Flos e Izan Beltran Ferreiro."
      ],
      egoiImage: egoi2,
      egoiDescripcion: "En octubre fuimos a Turquía a competir por segundo año consecutivo en la Olimpiada Europea de Informática Femenina (EGOI). Volvimos nada menos que con pleno de medallas: dos medallas de plata y dos de bronce, siendo la peor puntuación española muy superior a la mejor de otras potencias europeas. Este éxito apareció reflejado en numerosos medios de comunicación, como:",
      egoiLinks: [
        {url: "https://www.lavanguardia.com/vida/20221022/8577813/exito-espanol-palmares-competicion-europea-femenina-programacion.html", title: "La Vanguardia" },
        {url: "https://elpais.com/tecnologia/2022-10-28/la-olimpiada-informatica-femenina-europea-receta-contra-la-brecha-de-genero.html", title: "El País"},
        {url: "https://www.lne.es/sociedad/2022/10/23/ovetenses-champions-informatica-femenina-pleno-77591172.html", title: "La Nueva España"}
      ],
      premiosESO: [
        "Vera Morancho Bargas - mejor puntuación de 1º y 2º de la ESO",
        "Isabel Villar García - mejor puntuación de 3º y 4º de la ESO",
      ],
    },

    {
      id: "oifem-i",
      nombre: "OIFem I (2021)",
      teamEgoi: [
        {nombre: 'María Lucía Aparicio García', medalla: 'medalla de bronce'},
        {nombre: 'Victoria Durán Fernández', medalla: "participación"},
        {nombre: "Alexandra García Flórez", medalla: "participación"},
        {nombre: "Amal Dokkar El Hamoudi", medalla: "participación"}
      ],
      medallistas: [
        {nombre: "María Lucía Aparicio García", medalla: "medalla de oro"},
        {nombre: "Victoria Durán Fernández", medalla: "medalla de plata"},
        {nombre: "Alexandra García Flórez", medalla: "medalla de bronce"},
        {nombre: "Amal Dokkar El Hamoudi", medalla: "medalla de bronce"}
      ],
      finalistas: [
        {nombre: "Helena Folia Cots"},
        {nombre: "Adriana Aguiló Martínez"},
        {nombre: "Joana Pech Alberich"},
        {nombre: "María Elena Sánchez Grümmer"},
        {nombre: "Berta Vigo Blázquez"},
        {nombre: "Martina Agüera Sánchez"},
        {nombre: "Laia Mayné Arévalo"},
        {nombre: "Isabel Villar García"},
        {nombre: "Mar Vilardell Regué"},
        {nombre: "María Moronta Carrión"},
        {nombre: "Clara Gifra Puig"},
        {nombre: "Mireia López Bruch"}
      ],
      concursos: [
        {
            nombre: "OIFem",
            problemas: [
                { url: "https://www.hackerrank.com/oifem-2021-clasificatorio", nombre: "Problemas Concurso clasificatorio OIFem I (28/02/21)" },
                {url: "https://www.hackerrank.com/oifem-2021-final-dia1", nombre: "Problemas Final Día 1 (20/03/21)"},
                {url: "https://www.hackerrank.com/oifem-2021-final-dia-2", nombre: "Problemas Final Día 2 (21/03/21)"}
            ],
            soluciones: [
                {url: solucionesConcurso1oifem1, nombre: "Soluciones Concurso clasificatorio OIFem I (28/02/21)"},
                {url: oifemFinal1, nombre: "Soluciones Final Día 1 (20/03/21)"},
                {url: oifemFinal2, nombre: "Soluciones Final Día 2 (21/03/21)"}
            ]
        },
        {
            nombre: "EGOI",
            problemas: [
                {url: "https://egoi.ch/en/tasks/", nombre: "Problems EGOI 2021"}
            ],
            soluciones: []
        }
      ],
      fotos: [oifem1_foto1, oifem1_foto2, oifem1_foto3, oifem1_foto4, oifem1_foto5, oifem1_foto6, oifem1_foto7, oifem1_foto8, oifem1_foto9],
      comentarios: [
       {
            foto: lucia,
            mensajes: ["Esta I OIFem ha sido muy motivadora para mí, al haberme dado la posibilidad de descubrir y aprender programación competitiva e ir mejorando a lo largo de estos meses. El esfuerzo y trabajo por parte de los organizadores me ha permitido vivir esta gran experiencia y por la que estoy muy agradecida. Animo a todas las chicas que no la conozcan aún, a participar en la próxima edición, en ella encontrarán a otras chicas de su edad con inquietudes parecidas, no solo del campo de la programación sino también de las matemáticas. ¡Espero que os guste tanto como me ha gustado a mí y también veros a todas en la II OIFem!"],
            nombre: "Lucía"
        },
        {
            foto: victoria,
            mensajes: ["Cuando me inscribí en la OIFem no sabía lo que me iba a encontrar, ni si me iba a gustar, pero lo hice y no puedo estar más contenta con esa decisión. En tan solo unos pocos meses he ido descubriendo el mundo de la programación competitiva en el que ningún problema es como el anterior. En las clases aprendemos las técnicas y algoritmos para poder solucionar problemas que antes resultaban imposibles. Esto no significa que después de las clases los problemas no sean un reto, porque lo son y justo eso es lo emocionante. Una pena que el año que viene no pueda participar, pero animo a todas las que si que tengan la posibilidad de apuntarse que lo hagan: os encontraréis con retos, compañeras y entrenadores increíbles."],
            nombre: "Victoria"
        }
      ],
      otrasCompeticiones: [
        {
            titulo: "Olimpiada Informática Española",
            items: [
                "María Lucía Aparicio García - medalla de plata",
                "Laura Mandow Fuentes - finalista",
                "Helena Folia Cots - finalista",
                "Victoria Durán Fernández - finalista"
            ]
        },
        {
            titulo: "Olimpiadas de informática regionales",
            items: ["María Lucía Aparicio García - ganadora de Asturias"]
        }
      ],
      descripciones: [
        "La primera edición de la OIFem fue el comienzo de un proyecto lanzado con mucha ilusión, sin saber qué apoyo tendríamos de la industria y, sobre todo, si lograríamos consolidar una comunidad de adolescentes que programaran en España. En menos de un mes ya teníamos nuestros primeros patrocinadores, nuestras primeras alumnas y un plan de clases. La mayoría empezaban de cero o casi, pero en muy poco tiempo mejoraron muchísimo con los entrenamientos, alcanzando un nivel muy alto. Dadas las restricciones por la pandemia, tuvimos que organizar la final online pese a tenerlo todo organizado para poder hacerla en Barcelona."
      ],
      egoiImage: egoi1,
      egoiDescripcion: "Pese a que no pudimos celebrar la final en persona y conocer al grupo que habíamos formado, tuvimos la suerte (o desgracia) de que la Olimpiada Europea de ese año se hiciera de forma telemática desde la sede de cada país y pudiéramos participar desde Barcelona. Organizamos un par de actividades para que el resto de alumnas de la zona pudieran acercarse también- como una visita a Casa Milà (La Pedrera), como se puede ver en la foto- y conocerse y nos llevamos muy buen recuerdo de la experiencia, además de una medalla de bronce para María Lucía Aparicio García.",
      premiosESO: [
        "Ariadna Lidón Ardanuy - mejor puntuación de 1º y 2º de la ESO",
        "Amal Dokkar El Hamoudi - mejor puntuación de 3º y 4º de la ESO",
      ],
    },
  ];

  return (
    <div className='historico'>
      <div className='destacado'>
        <h1>Histórico</h1>
        <p>
          La OIFem nació a finales de 2020. Aquí encontrarás una cronología con información sobre cada edición, sus actividades y los éxitos de ese año, tanto en la Olimpiada Europea Femenina 
          de Informática (EGOI, competición a la que se clasifican las cuatro finalistas de la OIFem con mejor puntuación) como en otras competiciones.
        </p>
      </div>

      <div className='sticky'>
        <div>
          <label htmlFor='edicion'>Edición</label>
          <select 
            id="edicion" 
            value={edicionSeleccionada} 
            onChange={(e) => setEdicionSeleccionada(e.target.value)}
          >
            <option value="todas">Todas las ediciones</option>
            {ediciones.map((edicion) => (
              <option key={edicion.id} value={edicion.id}>
                {edicion.nombre}
              </option>
            ))}
          </select>
        </div>
      </div>

      {edicionSeleccionada === "todas" ? (
        ediciones.map(edition => (
          <EditionSection key={edition.id} edition={edition} />
        ))
      ) : (
        ediciones
          .filter(e => e.id === edicionSeleccionada)
          .map(edition => (
            <EditionSection key={edition.id} edition={edition} />
          ))
      )}
    </div>
  );
}